// extracted by mini-css-extract-plugin
export default {"payBefore":"index-module__payBefore___oaEgq","payBeforeText":"index-module__payBeforeText___K_lpU","timer":"index-module__timer___t9N_2"};